import { ScreenContext } from '@/contexts'
import {ReactNode} from "react";

export const withScreenInfo = (WrappedComponent:(props: any) => ReactNode) => (props:Record<string, unknown>) =>
    (
        <ScreenContext.Consumer>
          {(screen) => (<WrappedComponent {...props} screen={screen} />)}
        </ScreenContext.Consumer>
      )
